import { ConfiguratorAction, ConfiguratorActionEnum } from "helpers/context/Configurator/ConfiguratorContext";
import { IBearerToken } from "helpers/interfaces";
import { isNullOrWhiteSpace } from "helpers/objects";

export default class ConfiguratorHandler {

    #dispatch: React.Dispatch<ConfiguratorAction>;

    constructor(dispatch: React.Dispatch<ConfiguratorAction>) {
        this.#dispatch = dispatch;
    }

    private SetEmbedded = () => {
        this.#dispatch({ action: ConfiguratorActionEnum.SetEmbedded, value: true });
    }

    private SetConfigurator = (configurator: string) => {
        this.#dispatch({ action: ConfiguratorActionEnum.SetConfigurator, value: configurator });
    }

    public SetInstanceIsEmbedded() {
        this.SetEmbedded();
    }

    public SetConfiguratorMode(configurator: string) {
        this.SetConfigurator(configurator);
    }

    public PostLoginSuccess(configurator: string) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "login-success"
            }, "*");
        }
    }

    public PostTokenLoginSuccess(configurator: string, token: IBearerToken) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "token-login-success",
                message: token
            }, "*");
        }
    }

    public PostProductNavigatorCancel(configurator: string) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "prodnav-cancel"
            }, "*");
        }
    }

    public PostOptionsWizardCancel(configurator: string) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "wizard-cancel"
            }, "*");
        }
    }

    public PostOptionsWizardSave(configurator: string, odKey: number) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "wizard-save",
                message: odKey
            }, "*");
        }
    }

    public PostGlobalOptionsSave(configurator: string) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "global-options-save"
            }, "*");
        }
    }

    public PostGlobalOptionsCancel(configurator: string) {
        if (window.parent !== null && !isNullOrWhiteSpace(configurator)) {
            // Default
            window.parent.postMessage({
                type: "global-options-cancel"
            }, "*");
        }
    }

};


